import React from "react";
import { Link } from "react-router-dom";
import { imgSrc } from "@/lib/api";
import { Star, MapPin } from "lucide-react";

const CAT_LABELS = {
  rehearsal: "Rehearsal",
  photo: "Photo / Video",
  meeting: "Meeting",
  fitness: "Fitness",
  event: "Event",
  popup: "Pop-up",
  other: "Other",
};

export default function ListingCard({ listing }) {
  const cover = listing.photos?.[0];
  return (
    <Link
      to={`/spaces/${listing.id}`}
      className="listing-card group block bg-white border border-neutral-200 rounded-xl overflow-hidden hover:border-neutral-900 transition-colors"
      data-testid={`listing-card-${listing.id}`}
    >
      <div className="aspect-[4/3] bg-neutral-100 overflow-hidden">
        {cover ? (
          <img
            src={imgSrc(cover)}
            alt={listing.title}
            className="card-image w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-neutral-400 text-sm">No photo</div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-neutral-500 mb-1">
              {CAT_LABELS[listing.category] || listing.category}
            </div>
            <div className="font-display font-bold text-lg leading-tight truncate">{listing.title}</div>
            <div className="flex items-center text-xs text-neutral-600 mt-1 gap-1">
              <MapPin className="w-3 h-3" /> {listing.city}
            </div>
          </div>
          {listing.reviews_count > 0 && (
            <div className="flex items-center gap-1 text-sm shrink-0">
              <Star className="w-3.5 h-3.5 fill-[#FF4500] text-[#FF4500]" />
              <span className="font-medium">{listing.rating.toFixed(1)}</span>
            </div>
          )}
        </div>
        <div className="mt-3 pt-3 border-t border-neutral-100 flex items-baseline justify-between">
          <div>
            <span className="font-display font-black text-2xl">${listing.price_per_hour}</span>
            <span className="text-xs text-neutral-500"> / hour</span>
          </div>
          <span className="text-xs font-mono uppercase tracking-widest text-[#FF4500] opacity-0 group-hover:opacity-100 transition-opacity">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
}
